import React, { Component } from 'react';
import { Printer, Download, Loader } from 'react-feather';
import download from 'downloadjs';
import moment from 'moment';
import PropTypes from 'prop-types';
import getLabel from '../../translations/messages';
import { fetchDownload } from '../../cruds/remote';
import { classNames } from '../../functions/classNames';
import './DownloadButton.css';

class DownloadButton extends Component {
  constructor(props) {
    super(props);
    this.state = { isDownloading: false };
  }

  handleClick = () => {
    if (this.state.isDownloading) {
      return;
    }

    this.setState({ isDownloading: true }, this.downloadFile);
  };

  getFileName = () => {
    const { from, extension, fileName } = this.props;

    if (fileName) {
      return fileName;
    }

    const now = moment().format('DDMMYYYY_HHmmss');
    return 'export_' + from + '_' + now + '.' + extension;
  };

  getUrl = () => {
    const { url, from, extension } = this.props;

    if (url) {
      return url;
    }

    return from + '/' + extension;
  };

  downloadFile = () => {
    const fileName = this.getFileName();
    const url = this.getUrl();
    const updatedFilters = { ...this.props.filters };
    updatedFilters.maxResults = 0;

    fetchDownload(url, updatedFilters)
      .then(res => {
        download(res, fileName, this.props.type);
        this.setState({ isDownloading: false });
      })
      .catch(err => this.setState({isDownloading: false},
                () => {this.props.handleError(err.message? err.message : err.statusText, null, false)}
              ));
        

  };

  renderIcon = () => {
    if (this.state.isDownloading) {
      return <Loader size={18} />;
    }

    if (this.props.iconType === 'button') {
      return <span>{getLabel(this.context.locale, 'general.print')}</span>;
    }

    if (this.props.iconType === 'printer') {
      return <Printer size={18} />;
    }

    return <Download size={18} />;

  };

  render() {
    const className = classNames('exportButton',
                          (this.state.isDownloading ? 'loading' : ''),
                          (this.props.iconType === 'button' ? 'Button btn-orange' : '')
                      );
    return (
      <span className="DownloadButton" style={this.props.style}>
        {this.props.tooltip ?
          <span className={classNames('tooltip', this.props.wide ? 'tooltip-wide' : '')}>
            {getLabel(this.context.locale, this.props.tooltip)}
          </span>
        : ''}
        <a className={className} onClick={this.handleClick}>
          {this.renderIcon()}
        </a>
      </span>

    );
  }

}

DownloadButton.contextTypes = {
  locale: PropTypes.string,
};

export default DownloadButton;



// WEBPACK FOOTER //
// ./src/main/components/output/DownloadButton.js